import React from 'react';
import styled from 'styled-components';
import { itvThemeColor } from '../../Theming';
import { Trans } from 'react-i18next';

const Container = styled.div`
  padding-inline: 24px;
  padding-top: 24px;
`;

const Title = styled.span`
  font-family: Arial;
  font-weight: Bold;
  font-size: 16px;
  line-height: 30px;
  display: flex;
`;

const Msg = styled.span`
  font-family: Arial;
  font-size: 14px;
  line-height: 20px;
  display: flex;
`;

const StepsContainer = styled.div`
  padding-top: 20px;
`;

const StepItem = styled.div`
  display: flex;
  flex-direction: row;
  height: 30px;
  align-items: center;
`;

const StepTag = styled.div`
  height: 20px;
  width: 20px;
  border-radius: 20px;
  background-color: ${itvThemeColor('lightGreen')};
  font-size: 12px;
  font-weight: Bold;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const StepText = styled.span`
  font-family: Arial;
  font-size: 14px;
  line-height: 30px;
  margin-left: 10px;
`;

interface ActivationStepsProps {
  steps?: string[];
  title?: string;
  msg?: string;
}

const ActivationSteps: React.FC<ActivationStepsProps> = ({
  steps,
  title,
  msg,
}) => {
  return (
    <Container>
      <Title>{title}</Title>
      <Msg>{msg}</Msg>
      <StepsContainer>
        {steps?.map((item, index) => (
          <StepItem key={index}>
            <StepTag>{index}</StepTag>
            <Trans>
              <StepText>{item}</StepText>
            </Trans>
          </StepItem>
        ))}
      </StepsContainer>
    </Container>
  );
};

export default ActivationSteps;
